import {useNavigate} from "react-router-dom"

function SignupLoginButtons({className}) {
    const navigate = useNavigate()

    function navigateToSignUp() {
        navigate('/signup')
    }

    function navigateToLogin() {
        navigate('/login')
    }

    return (
        <div className={className}>
            <button onClick={navigateToSignUp}>Sign Up</button>
            <button onClick={navigateToLogin}>Login</button>
        </div>
    )
}

export default SignupLoginButtons